import React from 'react';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';
import Paragraph from '@tds/core-paragraph';

import { ContentWrapper } from '../design/css';

const Success = () => {
  return (
    <>
      <Box between={4}>
        <HairlineDivider />
        <HairlineDivider />
      </Box>
      <div className="container 85%">
        <ContentWrapper style={{ minHeight: 'auto' }}>
          <Paragraph>
          Thank you for choosing TELUS Microsoft 365 Cloud UC and Advisory Services.  We have received confirmation of the customer agreement and will proceed with the next steps to set up your solution as requested.
          </Paragraph>
          <br />
          <Paragraph>
          The next step is for our TELUS support agent to contact you by phone and onboard you to our TELUS Business Apps Portal and provision your services.
          </Paragraph>
          <br />
          <Paragraph>
          If you have any questions at this time, please contact your TELUS Account Manager.
          </Paragraph>
        </ContentWrapper>
      </div>
    </>
  );
};

export default Success;
